const vi = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'Mau đến học tiếng <br />Trung cùng Super Chinese với mình nhé!',
	'零基础任性学': 'Học vững chắc từ những bước đầu',
	'听说读写全面提升': 'Nâng cao toàn diện nghe-nói-đọc-viết',
	'趣味对话': 'Đoạn hội thoại gắn với cuộc sống',
	'100+日常对话等你来': 'Hơn 100 đoạn hội thoại đang đợi bạn',
	'智能AI': 'Nền tảng AI thông minh',
	'个性化学习推荐，由浅入深系统学': 'Khoá học được cá nhân hoá, học từ dễ đến khó',
	'趣味对话等你来': 'Đoạn hội thoại gần gũi với cuộc sống đang đợi bạn đó',
	'立即打开': 'Mở ngay',
	'我在SuperChinese<br />已累计学习{day}天': 'Mình đã học cùng Super Chinese<br /> <span>{day}</span> ngày',
	'我在SuperChinese<br />已连续学习{day}天': 'Mình đã học cùng Super Chinese<br /> <span>{day}</span> ngày',
	'学习生词': 'Từ vựng',
	'学习语法': 'Ngữ pháp',
	'口语练习': 'Luyện nói',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>lần',
	'点击右上角的按钮,选择在浏览器中打开': 'Bấm vào nút {...} ở góc trên bên phải,Lựa chọn mở trong trình duyệt',
	'邀请码': 'Mã giới thiệu',
	'用邀请码注册，参与抽大奖': 'Mời bạn bè đăng ký tài khoản và nhập mã giới thiệu là có thể tham gia quay số trúng thưởng.',
}
export default vi;